import * as React from "react";
import { Block } from "baseui/block";

import { Policy } from "../components";
import { GlobalsContext } from "../../util/Globals";

type TPolicyPage = {
  policyId?: string;
};
export function PolicyPage({ policyId }: TPolicyPage) {
  return (
    <GlobalsContext.Provider value="policies">
      <Block
        width="100%"
        marginTop="scale1000"
        marginBottom="80px"
        marginLeft={[0, 0, "initial"]}
        marginRight={[0, 0, "initial"]}
      >
        <Policy policyId={policyId} editing={false} />
      </Block>
    </GlobalsContext.Provider>
  );
}
